import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import PrivacyNoticeDialog from '../common/PrivacyNoticeDialog';
import HowToDialog from '../common/HowToDialog';
import './MenuBar.css';

const MenuBar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showTermsDialog, setShowTermsDialog] = useState(false);
  const [showHowToDialog, setShowHowToDialog] = useState(false);
  const { currentUser } = useAuth();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // 利用規約ダイアログを表示する関数
  const handleShowTerms = () => {
    setShowTermsDialog(true);
  };

  // 利用規約ダイアログを閉じる関数
  const handleCloseTerms = () => {
    setShowTermsDialog(false);
  };

  // アプリの使い方ダイアログを表示する関数
  const handleShowHowTo = () => {
    setShowHowToDialog(true);
  };

  // アプリの使い方ダイアログを閉じる関数
  const handleCloseHowTo = () => {
    setShowHowToDialog(false);
  };

  // Only show menu bar if user is logged in
  if (!currentUser) {
    return null;
  }

  return (
    <>
      <div className="menu-bar">
        <button 
          className="hamburger-button" 
          onClick={toggleSidebar}
          aria-label="メニューを開く"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={closeSidebar} 
        onShowTerms={handleShowTerms}
        onShowHowTo={handleShowHowTo}
      />
      <PrivacyNoticeDialog 
        isOpen={showTermsDialog} 
        onClose={handleCloseTerms}
        isFromSidebar={true}
      />
      <HowToDialog 
        isOpen={showHowToDialog} 
        onClose={handleCloseHowTo}
        isFromSidebar={true}
      />
    </>
  );
};

export default MenuBar;